import MembersModalAdmin from './members-modal';

export default MembersModalAdmin;
